/**
 * Parse a WebVTTSettingsBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed WebVTTSettingsBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function sttg(view) {
    return {
        settings: view.readUtf8(-1),
    };
}
;
//# sourceMappingURL=sttg.js.map